import React, {useState, useEffect} from 'react';
import axios from "axios";
import config from "../../../../config";


const useAccidents = (counter) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await axios.get(config.MAP_MATCHING_API_URL + `/accidents`,{
                    headers: { 'Content-Type': 'application/json',
                        "X-API-Key": `${config.MAP_MATCHING_API_TOKEN}`
                     }
                });;
                setData(response.data); // Save API data to state
                setLoading(false); // Data is loaded
            } catch (err) {
                setError("Error loading accidents data.");
                setLoading(false);
            }
        };

        fetchData();
    }, [counter]);

    return { data, loading, error };
};

export default useAccidents;